import env from '@/services/env';
import Client from 'shopify-buy';

// Initializing a client to return content in the store's primary language
export default Client.buildClient({
  domain: env.envURL,
  storefrontAccessToken: env.envID
});